export const SOCIAL_LINKS = {
  email: "mailto:info@vantage-360.com",
  linkedIn: "https://www.linkedin.com/company/vantage360inc/",
  companyLink: "https://www.vantage-360.com/",
  address: "https://maps.app.goo.gl/HXfz4ryJecixc4M17",
};
